var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.8516 0.676758C9.08269 0.676758 0.351562 7.51476 0.351562 15.9501C0.351562 21.4036 4.00131 26.1893 9.49219 28.89C6.76544 38.2321 5.16319 38.8399 16.3887 30.9814C17.5132 31.139 18.6702 31.2219 19.8516 31.2219C30.6204 31.2219 39.3516 24.3839 39.3516 15.9485C39.3516 7.51476 30.6204 0.676758 19.8516 0.676758Z",
    fill: "#3E2723"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.eb986b0cf810904357ff9ba6b1de3081.svg";
export { ForwardRef as ReactComponent };